import { Link } from "react-router-dom";
import type { Review } from "@/types";
import StarRating from "@/components/base/StarRating";

interface ReviewCardProps {
  review: Review;
  compact?: boolean;
}

export default function ReviewCard({ review, compact = false }: ReviewCardProps) {
  return (
    <Link
      to={`/review/${review.id}`}
      className="panel group block overflow-hidden rounded-lg transition-colors duration-300 hover:border-primary-500"
    >
      <div className="flex flex-col sm:flex-row">
        <div className={`relative w-full shrink-0 overflow-hidden ${compact ? "h-40 sm:h-auto sm:w-52" : "h-44 sm:h-auto sm:w-64"}`}>
          <img
            src={review.cover}
            alt={`${review.title} 配图`}
            title={`${review.title} - 激情丛林电影影评`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-background-950/80 px-2.5 py-1 font-label text-[11px] text-accent-400 backdrop-blur">
            {review.category}
          </span>
        </div>

        <div className="flex flex-1 flex-col p-4 md:p-5">
          <h3 className="font-heading text-base font-bold leading-snug text-foreground-50 transition-colors group-hover:text-accent-400">
            {review.title}
          </h3>
          <p className="mt-2 line-clamp-2-custom text-sm leading-relaxed text-foreground-400">
            {review.excerpt}
          </p>
          <div className="mt-auto flex flex-wrap items-center justify-between gap-3 pt-4">
            <span className="flex items-center gap-2 font-label text-xs text-foreground-500">
              <i className="ri-user-3-line"></i>
              {review.author} · {review.source}
            </span>
            <div className="flex items-center gap-3">
              <StarRating rating={review.rating} showValue />
              <span className="font-label text-xs text-foreground-500">{review.date}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}